import { TariffCode } from "@iloq/shared";

enum ReturnReason {
  BATTERY,
  CLINGING,
  CLOCK,
  COATING,
  CONNECTOR,
  CORROSION,
  DAMAGE,
  DEAD,
  ERROR,
  FREEZE,
  ILOQSTUCK,
  INSERT,
  KEYFEEL,
  KEYJUMPS,
  KEYSTUCK,
  LOOSE,
  NOSOUND,
  NOTAG,
  NOWARRA,
  NOWORK,
  ONLINE,
  OTHER,
  OUTSIDE,
  PIECES,
  POWER,
  RANDOM,
  SCREW,
  TAGWORK,
  THREADS,
  UPDATE,
  WIRE,
  WORN,
}

enum ProblemOccurence {
  WHILE_UNPACKING,
  BEFORE_INSTALLING,
  BEFORE_INSTALLING_DURING_FORMATTING,
  BEFORE_INSTALLING_DURING_PROGRAMMING,
  BEFORE_INSTALLING_DURING_RESET,
  BEFORE_INSTALLING_DURING_RESET_TO_FACTORY_SETTINGS,
  WHILE_INSTALLING,
  WHILE_IN_USE,
}

export function getCategoryTypes() {
  return Object.values(TariffCode).map((code: string) => ({
    value: code,
    label: `productReturn.common.customsInformation.categories.${code}`,
  }));
}

export function getReturnReasonTypes() {
  return Object.keys(ReturnReason)
    .filter((key) => isNaN(Number(key)))
    .map((key: string) => ({
      value: key,
      label: `productReturnV2.returnReason.${key}`,
    }));
}

export function getProblemOccurenceTypes() {
  return Object.keys(ProblemOccurence)
    .filter((key) => isNaN(Number(key)))
    .map((key: string) => ({
      value: key,
      label: `productReturnV2.problemOccurence.${key}`,
    }));
}
